export const admissionYears = [25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15] as const;
